import { FormControl } from '@mui/material';

import { GDMFormControlComponent } from './GDMFormControl.type';

/* TODO: Implement component using GDM default design */
const GDMFormControl: GDMFormControlComponent = props => <FormControl {...props} />;

export default GDMFormControl;
